import { SR_API_ACTION_GET_USER_SUGGESTED_SEARCH_FILTERS } from 'api/actionTypes';

export default async function getSuggestedSearchFilters({ state, apiClient }) {
  if (!state.get(['search', 'suggestedSearchFilters'])) {
    const userSearchFilters = state.get(['currentUser', 'searchFilters']);
    await apiClient.postWithState({
      action: SR_API_ACTION_GET_USER_SUGGESTED_SEARCH_FILTERS,
      state: state,
      payload: {
        userSearchFilters: userSearchFilters,
      },
      onSuccess(suggestedSearchFilters) {
        state.set(['search', 'suggestedSearchFilters'], suggestedSearchFilters);
      },
    });
  }
}
